import { DEFAULT_DASHBOARD_ID } from "../context/dashboard-id"

// Unscoped key all dashboard preferences were stored under before per-dashboard scoping.
export const LEGACY_DASHBOARD_PREFERENCE_KEY = "dashboard"

export function getDashboardPreferenceKey(dashboardId: string): string {
  return `dashboard-${dashboardId}`
}

// Read-only migration fallback: the default dashboard keeps reading legacy rows until a save
// writes the scoped key. Non-default dashboards never had legacy rows, so no fallback.
export function getDashboardPreferenceFallbackKey(dashboardId: string): string | undefined {
  return dashboardId === DEFAULT_DASHBOARD_ID ? LEGACY_DASHBOARD_PREFERENCE_KEY : undefined
}
